<template>

    <v-table scrollable>
        <thead>
            <th></th>
            <th class="sortable" v-for="trait in traits" :key="trait.id" @click="sort(trait.field)">
                <div>
                    <span>{{ trait.name }}</span>
                    <i v-if="$route.query.sort_key === trait.field && $route.query.sort_dir === 'desc'" class="fas fa-caret-down"></i>
                    <i v-if="$route.query.sort_key === trait.field && $route.query.sort_dir === 'asc'" class="fas fa-caret-up"></i>
                </div>
            </th>
        </thead>
        <tbody>
            <tr v-for="customer in customers" :key="customer.id" @click="viewCustomer($event, customer)">
                <td class="w-34 pr-0">
                    <v-avatar
                        :name="customer.initials"
                        :color="customer.color"
                        :url="customer.gravatar ? customer.gravatar + '&s=80' : ''"
                        :size="34"
                        :radius="17">
                    </v-avatar>
                </td>
                <td v-for="trait in traits" :key="trait.id">
                    <v-value :value="customer | valueForTrait(trait)" />
                </td>
            </tr>
        </tbody>
    </v-table>

</template>

<script>

export default {

    props: {
        customers: {
            tyoe: Object,
            required: true,
        },
    },

    computed: {

        traits() {
            let traits = this.project.traits.filter(trait => {
                if (trait.visibility.list) {
                    return trait;
                }
            });
            return traits.sort((a, b) => a.sort - b.sort);
        },

    },

    methods: {

        viewCustomer(e, customer) {
            if (e.target?.tagName === 'A') return;
            let route = this.$router.resolve({
                name: 'customer',
                params: { id: customer.id },
            });
            window.open(route.href, '_blank');
        },

        sort(key) {
            let query = Object.assign({}, this.$route.query);
            let dir = query.sort_dir === 'desc' ? 'asc' : 'desc';
            query.sort_key = key;
            query.sort_dir = dir;
            this.$router.replace({ query: query }).catch(() => {});
        },

    }

}

</script>
